const CDN = 'https://d15cibqe80ctc1.cloudfront.net';
import { typeIdLand } from './nft-types';

interface ParcelConfig {
  type: string;
  baseURL: string;
  previewURL: string;
}

function getParcels(baseUrl, previewUrl) {
  let parcels = <ParcelConfig[]>[];
  for (let i = 1; i < 9; i++) {
    let type = String.fromCharCode(64 + i) + i; // 65 => "A" + 1, 66 => "B" + 2
    parcels.push({
      type: typeIdLand[i.toString()],
      baseURL: `${baseUrl}/${type}/${type}_1/`,
      previewURL: `${previewUrl}/${i}.png`,
    });
  }
  return parcels;
}

export const landTemplates = {
  cyberpunk: {
    parcels: getParcels(
      `${CDN}/CYBERPUNK_2023/landTemplates`,
      `${CDN}/CYBERPUNK_2023/landMedia`
    ),
  },
  flowzone: {
    parcels: getParcels(
      `${CDN}/FLOW_2023/landTemplates`,
      `${CDN}/FLOW_2023/landMedia`
    ),
  },
};
